// Inline text for the competitive analysis (views/CompetitiveAnalysis.vue). The report's text
// fields use a tiny markdown subset — **bold**, *italic*, [text](https://url) — and everything
// else is escaped, so the result is safe for v-html. Mirrors competitive-watch/scripts/mdlite.py.

function escapeHtml(s: string): string {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const LINK = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
const BOLD = /\*\*(.+?)\*\*/g;
// No lookbehind: older iOS Safari can't parse it, and this module is in the main bundle
const EM = /(^|[^*\w])\*(\S(?:.*?\S)?)\*(?![*\w])/g;

export function inlineText(text: string): string {
    if(!text) {
        return '';
    }
    const links: [string, string][] = [];
    let s = text.replace(LINK, (_m, label, url) => {
        links.push([label, url]);
        return `\uE000${links.length - 1}\uE000`;
    });
    s = escapeHtml(s).replace(BOLD, '<strong>$1</strong>').replace(EM, '$1<em>$2</em>');
    return s.replace(/\uE000(\d+)\uE000/g, (_m, i) => {
        if (!links[+i]) return _m;
        const [label, url] = links[+i];
        return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener">${escapeHtml(label).replace(BOLD, '<strong>$1</strong>')}</a>`;
    });
}

export function niceDate(iso: string): string {
    if(!iso) {
        return '';
    }
    return new Date(iso + 'T12:00:00').toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

export function sourceUrl(value: string): string | undefined {
    try { const u = new URL(value); return ['https:', 'http:'].includes(u.protocol) && !u.username && !u.password ? u.href : undefined; }
    catch { return undefined; }
}
